/**
 * Development mode configuration
 * Allows bypassing authentication for testing
 */

export const DEV_CONFIG = {
  // Enable mock authentication in development
  enableMockAuth: import.meta.env.DEV && import.meta.env.VITE_ENABLE_MOCK_AUTH === 'true',

  // Mock user data
  mockUser: {
    id: 'dev-user-123',
    name: 'Dev User',
    email: 'dev.user@stellar.local',
    avatar: undefined,
  },

  // Mock access token (not a real token)
  mockAccessToken: 'mock-access-token-for-development',

  // Skip actual API calls
  mockApiCalls: import.meta.env.DEV && import.meta.env.VITE_MOCK_API === 'true',
};
